module.exports = __webpack_public_path__ + "img/google.81450643.png";